var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",staticStyle:{"height":"100%","max-width":"100%"}},[_c('div',{staticClass:"card-title",staticStyle:{"border":"none"}},[_vm._v("Address count")]),_vm._v(" "),_c('line-chart',{attrs:{"hide-legend":"","labels":_vm.labels,"datasets":_vm.datasets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }